import React from 'react';
import { graphql } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Gallery from '../components/gallery'
import ProductMeta from '../components/products/productMeta'
import {GatsbyImage,getImage} from 'gatsby-plugin-image'
import '../styles/product-single.scss';

export default function ProductPage ({data}) {
    const {price} = data;
    const schema = `{
      "@context": "https://schema.org/",
      "@type": "Product",
      "name": "${price.product.name}",
      "image": [${price.product.localFiles.map(({publicURL}) => {return `"${typeof window !== `undefined` ? window.location.origin : ''}${publicURL}"`})}],
      "description": "${price.product.description}",
      "sku": "${price.id}",
      "offers": {
        "@type": "Offer",
        "price": "${(price.unit_amount / 100).toFixed(2)}",
        "priceCurrency": "${price.currency}"
      }
    }`;
    const productImages = [];
    price.product.localFiles.map((file) => {
        let image = getImage(file)
        productImages.push(<GatsbyImage objectFit="contain" key={file.childImageSharp.id} image={image} alt={price.product.name} />)
    })
    return (
        <Layout>
            <SEO title={price.product.name} keywords={price.product.metadata.keywords} >
              <script type="application/ld+json">
                {schema}
              </script>
            </SEO>
            <article>
                <h1>{price.product.name}</h1>
                <p className='fade'>{price.product.description}</p>
                <div className='product-frame fade'>
                    <Gallery images={productImages} />
                    <aside>
                        <ProductMeta price={price} />
                    </aside>
                </div>
            </article>
        </Layout>
    )
}

export const query = graphql`
  query MdxBlogPost($title: String) {
    price: stripePrice(product: {name: {eq: $title}}) {
        id
        product {
          description
          metadata {
              keywords
          }
          localFiles {
            publicURL
            childImageSharp {
              id
              gatsbyImageData(
                placeholder: BLURRED,
                formats: [AUTO,WEBP,AVIF],
                transformOptions: {fit:CONTAIN}
              )
            }
          }
          name
        }
        unit_amount
        currency
    }
  }
`